import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.login.pageTitle',
    defaultMessage: 'Accedi a MyAzimut',
    description: 'Title of the login page',
  },
  pageSubtitle: {
    id: 'features.login.pageSubtitle',
    defaultMessage: "Inserisci l'username e la password per l'accesso",
    description: 'Subtitle of the login page',
  },
  assistanceDisclaimer: {
    id: 'features.login.assistanceDisclaimer',
    defaultMessage:
      'Supporto Tecnico: 02.8898.7005 Attivo Lun-Ven, 9:00 - 18:00\n(costo di una chiamata nazionale in base al proprio operatore telefonico).',
  },
  attemptsDisclaimer: {
    id: 'features.login.attemptsDisclaimer',
    defaultMessage:
      'ATTENZIONE: Dopo 5 errori nella digitazione della password il tuo account verrà' +
      ' bloccato: potrai riattivarlo tramite apposita funzione',
    description: '',
  },
  loginButton: {
    id: 'features.login.loginButton',
    defaultMessage: 'Accedi',
    description: 'Label of the login button',
  },
  usernameLabel: {
    id: 'features.login.usernameLabel',
    defaultMessage: 'Username',
    description: 'Label shown above the username input field',
  },
  usernamePlaceholder: {
    id: 'features.login.usernamePlaceholder',
    defaultMessage: 'Inserisci la tua username',
    description: 'Placeholder of the username input field',
  },
  usernamePlaceholderEmail: {
    id: 'features.login.usernamePlaceholderEmail',
    defaultMessage: 'Inserisci la tua email',
    description: 'Placeholder of the username input field',
  },
  passwordLabel: {
    id: 'features.login.passwordLabel',
    defaultMessage: 'Password',
    description: 'Label shown above the password input field',
  },
  passwordPlaceholder: {
    id: 'features.login.passwordPlaceholder',
    defaultMessage: 'Inserisci la tua password',
    description: 'Placeholder of the password input field',
  },
  errorInvalidCredential: {
    id: 'features.login.errorInvalidCredential',
    defaultMessage: 'Password non valida. Si prega di verificare',
    description: 'Error description for invalid credentials',
  },
  errorTitleFillInAllFields: {
    id: 'features.login.errorTitleFillInAllFields',
    defaultMessage: 'Inserire username e password per accedere a MyAzimut',
    description: 'Error description for fields not fill',
  },
  toggleRememberMe: {
    id: 'features.login.toggleRememberMe',
    defaultMessage: 'Ricordami',
    description: 'text on the toggle for remember the credential',
  },
  forgottenPasswordLink: {
    id: 'features.login.forgottenPasswordLink',
    defaultMessage: 'Password dimenticata?',
    description: 'link text for the people who forgot the password',
  },
  retrieveCredentialLink: {
    id: 'features.login.retrieveCredentialLink',
    defaultMessage: 'Recupero credenziali',
    description: 'Text For link to retrieve credential',
  },
  retrieveUsernameLink: {
    id: 'features.login.retrieveUsernameLink',
    defaultMessage: 'Recupero username',
    description: 'Text For link to retrieve username',
  },
  notSignUp: {
    id: 'features.login.notSignUp',
    defaultMessage: 'Non sei registrato? ',
    description: 'text that ask to the user if he has an account',
  },
  signUp: {
    id: 'features.login.signUp',
    defaultMessage: 'Registrati',
    description: 'link text fot the people who need to sign up',
  },
  selectRubrica: {
    id: 'features.login.selectRubrica',
    defaultMessage: 'Selezione rubrica',
    description: 'Seleziona rubrica',
  },
  setContextTitle: {
    id: 'features.login.setContextTitle',
    defaultMessage: "Selezionare una rubrica per accedere all'area riservata",
    description: 'Seleziona rubrica',
  },
  biometricLoginButton: {
    id: 'features.login.biometricLoginButton',
    defaultMessage: 'Accedi con biometria',
    description: 'Label of the biometric login button',
  },
  biometricPromptMessage: {
    id: 'features.login.biometricPromptMessage',
    defaultMessage: 'Accedi con biometria a MyAzimut',
    description: 'Message shown in the biometric prompt',
  },
  biometricSuccess: {
    id: 'features.login.biometricSuccess',
    defaultMessage: 'Autenticazione biometrica riuscita',
    description: 'Success message for biometric authentication',
  },
  biometricFailure: {
    id: 'features.login.biometricFailure',
    defaultMessage: 'Autenticazione biometrica fallita',
    description: 'Failure message for biometric authentication',
  },
  errorTooManyRequests: {
    id: 'features.login.errorTooManyRequests',
    defaultMessage:
      "Non è possibile procedere con l'accesso: hai superato il numero massimo di richieste. Riprova più tardi.",
    description: 'Error message when too many temporary passwords were requested (HTTP 429)',
  },
});
